var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 0.267334C7.24316 0.267334 3.13241 3.03601 1.19141 7.04996H22.8099C20.869 3.03601 16.7582 0.267334 12.0007 0.267334Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.2687C16.7582 24.2687 20.869 21.5 22.81 17.4861H1.19141C3.13241 21.5 7.24316 24.2687 12.0007 24.2687Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 16.4393C14.3052 16.4393 16.174 14.5706 16.174 12.2654C16.174 9.96027 14.3052 8.09155 12.0001 8.09155C9.69489 8.09155 7.82617 9.96027 7.82617 12.2654C7.82617 14.5706 9.69489 16.4393 12.0001 16.4393Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 14.8753C13.44 14.8753 14.608 13.7074 14.608 12.2666C14.608 10.8259 13.44 9.65796 11.9993 9.65796C10.5586 9.65796 9.39062 10.8259 9.39062 12.2666C9.39062 13.7074 10.5586 14.8753 11.9993 14.8753Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 9.04858L12.8055 10.8738L14.7885 10.6581L13.6102 12.2677L14.7885 13.8772L12.8055 13.6616L12.0007 15.4868L11.1959 13.6616L9.21289 13.8772L10.3911 12.2677L9.21289 10.6581L11.1959 10.8738L12.0007 9.04858Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/INR.71ca814617f9cb79be454c95a7f0e6c9.svg";